import { fetchRequestWithTypes } from './index.js';

export const GET_ACCOUNT_AGREEMENTS_REQUEST = 'GET_ACCOUNT_AGREEMENTS_REQUEST';
export const GET_ACCOUNT_AGREEMENTS_SUCCESS = 'GET_ACCOUNT_AGREEMENTS_SUCCESS';
export const GET_ACCOUNT_AGREEMENTS_ERRORED = 'GET_ACCOUNT_AGREEMENTS_ERRORED';

export const getAccountAgreements = (retireAccountType) => {
	const query = retireAccountType ? `?retireAccountType=${retireAccountType}` : '';
	return fetchRequestWithTypes({
		types: [
			GET_ACCOUNT_AGREEMENTS_REQUEST,
			GET_ACCOUNT_AGREEMENTS_SUCCESS,
			GET_ACCOUNT_AGREEMENTS_ERRORED,
		],
		request: {
			method: 'GET',
			path: `/apis/customers/v1/subscriptions/agreements/brokerage${query}`,
		},
	});
};

// Post a new account (ROTH_IRA, PERSONAL_BROKERAGE, TRADITIONAL_IRA, CUSTODIAN)
// https://staging.stsh.io/documentation/1.0/accounts/create.html

export const POST_ACCOUNT_REQUEST = 'POST_ACCOUNT_REQUEST';
export const POST_ACCOUNT_SUCCESS = 'POST_ACCOUNT_SUCCESS';
export const POST_ACCOUNT_ERRORED = 'POST_ACCOUNT_ERRORED';

export const postAccount = (body) =>
	fetchRequestWithTypes({
		types: [POST_ACCOUNT_REQUEST, POST_ACCOUNT_SUCCESS, POST_ACCOUNT_ERRORED],
		request: {
			method: 'POST',
			path: '/api/v1/users/:uuid/accounts',
			body,
		},
	});

// Submits an account's application to Apex
// https://staging.stsh.io/documentation/1.0/accounts/submit_application.html

export const POST_ACCOUNT_SUBMIT_REQUEST = 'POST_ACCOUNT_SUBMIT_REQUEST';
export const POST_ACCOUNT_SUBMIT_SUCCESS = 'POST_ACCOUNT_SUBMIT_SUCCESS';
export const POST_ACCOUNT_SUBMIT_ERRORED = 'POST_ACCOUNT_SUBMIT_ERRORED';

export const postAccountSubmit = (accountId, body) =>
	fetchRequestWithTypes({
		types: [POST_ACCOUNT_SUBMIT_REQUEST, POST_ACCOUNT_SUBMIT_SUCCESS, POST_ACCOUNT_SUBMIT_ERRORED],
		request: {
			method: 'POST',
			path: `/api/v1/users/:uuid/accounts/${accountId}/submit`,
			body,
		},
	});

export const POST_ACCOUNT_AND_SUBMIT_REQUEST = 'POST_ACCOUNT_AND_SUBMIT_REQUEST';
export const POST_ACCOUNT_AND_SUBMIT_SUCCESS = 'POST_ACCOUNT_AND_SUBMIT_SUCCESS';
export const POST_ACCOUNT_AND_SUBMIT_ERRORED = 'POST_ACCOUNT_AND_SUBMIT_ERRORED';

export const postAccountAndSubmit = (body) =>
	fetchRequestWithTypes({
		types: [
			POST_ACCOUNT_AND_SUBMIT_REQUEST,
			POST_ACCOUNT_AND_SUBMIT_SUCCESS,
			POST_ACCOUNT_AND_SUBMIT_ERRORED,
		],
		request: {
			method: 'POST',
			path: '/api/v1/users/:uuid/accounts/create_and_submit',
			body,
		},
	});

export const GET_ACCOUNTS_REQUEST = 'GET_ACCOUNTS_REQUEST';
export const GET_ACCOUNTS_SUCCESS = 'GET_ACCOUNTS_SUCCESS';
export const GET_ACCOUNTS_ERRORED = 'GET_ACCOUNTS_ERRORED';

export const getAccounts = () =>
	fetchRequestWithTypes({
		types: [GET_ACCOUNTS_REQUEST, GET_ACCOUNTS_SUCCESS, GET_ACCOUNTS_ERRORED],
		request: {
			method: 'GET',
			path: `/api/v1/users/:uuid/accounts`,
		},
	});
